import { gql } from '@apollo/client';

/**
 * The inbox merges two sources server-side — the announcement board and the
 * rows addressed to one person — so this screen asks one question and gets one
 * ordered list back. `id` is an opaque handle; hand it to the mark-read
 * mutations rather than taking it apart.
 */
export const MY_NOTIFICATIONS = gql`
  query MyNotifications($unreadOnly: Boolean, $category: String, $limit: Int, $skip: Int) {
    myNotifications(unreadOnly: $unreadOnly, category: $category, limit: $limit, skip: $skip) {
      id
      source
      category
      kind
      title
      body
      link
      entityType
      entityId
      actorName
      createdAt
      readAt
    }
  }
`;

export const MY_NOTIFICATION_SUMMARY = gql`
  query MyNotificationSummary {
    myNotificationSummary {
      unreadCount
      totalCount
    }
  }
`;

/**
 * The announcement board itself, for the admin panel. No expiry filter: the
 * point of the list is to see what is live and what has lapsed, which is the
 * one thing the reader's inbox deliberately hides.
 */
export const ANNOUNCEMENTS = gql`
  query Announcements {
    notifications(orderBy: updatedAt_DESC, limit: 100) {
      id
      subject
      description
      expiresAt
      updatedAt
      roles
    }
  }
`;
